<template>
    <div class="tablon" :style="{maxWidth: (ficha.attr.container && ficha.attr.container == 'fluid') ? '' : '1200px'}">
        
        <!-- Editor add-row -->
        <Editor :ficha="ficha" type="add-row" />

        <template v-if="tab.nombre == 'Relaciones'">
            <el-row>
                <el-col :span="24">
                    <PorletGroup
                    :ficha="ficha"
                    :id="id"
                    :entidad="entidad"
                    :porlets="tab.cols.map(column => column.elementos)[0]"
                    @afterActions="(val) => $emit('afterActions',val)"
                    @setCurrentAction="(val) => $emit('setCurrentAction', val)"
                    @saved="(val) => $emit('saved',val)"
                    @reloadDataTable="val => $emit('reloadDataTable',val)"/>
                </el-col>
            </el-row>
        </template>
        <template v-else>
            <el-row :gutter="15">
                <el-col v-for="(column, c) in tab.cols" :key="c" :span="windowWidth <= 991 ? 24 : column.cols" style="position: relative">

                    <!-- EDITOR -->
                    <Editor :ficha="ficha" type="add-porlet"/>

                    <div v-for="(elemento, e) in column.elementos">

                        <Porlet
                        :ref="`porlet_${elemento.id}`"
                        :inputList="inputList"
                        :key="e"
                        :ficha="ficha"
                        :id="id"
                        :activetab="activetab"
                        :entidad="entidad"
                        :porlet="elemento"
                        :belongsTab="tab.nombre"
                        :showMargin="elemento.attr && elemento.attr.hasOwnProperty('showMargin') ? elemento.attr.showMargin: ''"
                        :showHeader="elemento.attr && elemento.attr.hasOwnProperty('showHeader') ? elemento.attr.showHeader : true"
                        :showFooter="elemento.attr && elemento.attr.hasOwnProperty('showFooter') ? elemento.attr.showFooter : true"
                        :showShadow="elemento.attr && elemento.attr.hasOwnProperty('showShadow') ? elemento.attr.showShadow : true"
                        :height="elemento.attr && elemento.attr.hasOwnProperty('height') ? elemento.attr.height : null"
                        :marginBottom="elemento.attr && elemento.attr.hasOwnProperty('marginBottom') ? elemento.attr.marginBottom : true"
                        @afterActions="(val) => $emit('afterActions',val)"
                        @setCurrentAction="(val) => $emit('setCurrentAction', val)"
                        @saved="(val) => $emit('saved',val)"
                        @setActionId="(val) => $emit('setActionId', val)"
                        @reloadDataTable="(val) => $emit('reloadDataTable',val)"
                        @openWindow="(val) => $emit('openWindow',val)"
                        @dblClickSearch="(val) => $emit('dblClickSearch',val)"
                        @refsInputs="(val) => inputList.push(...val)"/>
                        
                    </div>
                </el-col>

                <!-- EDITOR -->
                <Editor :params="tab" :ficha="ficha" type="row" />
            </el-row>
        </template>
    </div>
</template>

<script>
    import PorletGroup from '@/components/Porlet/PorletGroup.vue'
    import Editor from '@/components/Editor/Editor.vue'
    
	export default {
		name: 'Tablon',
		components:{
            PorletGroup,
            Editor
		},
		props: {
            ficha: Object,
            id: [Number,String],
            entidad: String,
            tab: Object,
            activetab: String
        },
        data () {
            return {
                inputList: []
            }
        }
	}

</script>

<style lang="scss">
</style>
